<div class="dial-scope-modal" data-automation="dial-scope-modal">
  <!-- Inclusions -->
  <div class="dial-scope-section">
    <h6 class="fw-bold">
      {{ 'tkey;admin.teams_voice_management.teams_auto_attendant.dial_scope.modal.include.heading' | translate }}
    </h6>
    <p class="text-muted small mb-3">
      {{ 'tkey;admin.teams_voice_management.teams_auto_attendant.dial_scope.modal.include.description' | translate }}
    </p>

    <ziro-radio [fieldId]="'inclusionMode'"></ziro-radio>
    <ziro-select [fieldId]="'inclusionGroups'" [inlineLabel]="false"></ziro-select>
  </div>

  <hr />

  <!-- Exclusions -->
  <div class="dial-scope-section">
    <h6 class="fw-bold">
      {{ 'tkey;admin.teams_voice_management.teams_auto_attendant.dial_scope.modal.exclude.heading' | translate }}
    </h6>
    <p class="text-muted small mb-3">
      {{ 'tkey;admin.teams_voice_management.teams_auto_attendant.dial_scope.modal.exclude.description' | translate }}
    </p>

    <ziro-radio [fieldId]="'exclusionMode'"></ziro-radio>
    <ziro-select [fieldId]="'exclusionGroups'" [inlineLabel]="false"></ziro-select>
  </div>
</div>
